import {
  OutlinedInput,
  InputAdornment,
  Button,
  makeStyles,
  Box,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    textAlign: "center",
  },
  searchBar: {
    width: "90%",
    height: 50,
    marginTop: 8,
    borderRadius: "99px",
    backgroundColor: theme.searchBarGray,
    boxShadow: "inset 0px 6px 14px -5px rgba(112,112,112,1)",
    [`& fieldset`]: {
      borderRadius: "99px",
      borderColor: theme.gray,
      borderWidth: "0px",
    },
  },
  helperText: {
    justifySelf: "center",

    color: theme.red,
  },
  searchBar_searchButton: {
    width: 80,
    height: 48,
    borderRadius: "0 99px 99px 0",
    marginRight: -14,
    boxShadow: "inset 0px 6px 14px -5px rgba(112,112,112,1)",
  },
}));

const SearchBarwithButton = ({
  placeholder,
  onChange,
  onSearch,
  className,
  noIcon,
  buttonLabel = "Search",
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <OutlinedInput
        margin="normal"
        placeholder={placeholder}
        className={classes.searchBar}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onSearch();
          }
        }}
        startAdornment={noIcon ? null : <SearchIcon />}
        endAdornment={
          <InputAdornment position="end">
            <Button
              variant="contained"
              color="primary"
              className={[classes.searchBar_searchButton, className]}
              onClick={onSearch}
            >
              {buttonLabel}
            </Button>
          </InputAdornment>
        }
        onChange={onChange}
      ></OutlinedInput>
    </Box>
  );
};

export default SearchBarwithButton;
